import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { InvoiceList } from "@/features/invoices/components/invoice-list";
import { useDocumentTitle } from "@/hooks/use-document-title";

export const Route = createFileRoute("/(app)/dashboard/invoices/")({
  component: InvoicesPage,
});

function InvoicesPage() {
  const { t } = useTranslation();
  useDocumentTitle('invoices.title');
  
  return (
    <div className="w-full max-w-full space-y-4 md:space-y-6 overflow-hidden">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight md:text-3xl">{t('invoices.title')}</h1>
          <p className="text-sm text-muted-foreground md:text-base">
            {t('invoices.description')}
          </p>
        </div>
        <Link to="/dashboard/invoices/new" className="w-full sm:w-auto shrink-0">
          <Button className="w-full sm:w-auto">
            <Plus className="mr-2 h-4 w-4" />
            {t('invoices.newInvoice')}
          </Button>
        </Link>
      </div>

      <InvoiceList />
    </div>
  );
}
